import React from "react";
import loadable from "@loadable/component";
import { buildUrl, origins } from "../../utils/environment-urls";
import { addImportDependencies } from "../../utils/lazyLoad";
import { UploadFilePanelContainer } from "./upload-file-panel.styled";

const QuoteComponentUrl = buildUrl(
  `${origins.hosted}/quoting/quote/microcomponents/quote-upload.mjs`
);

const QuoteUploadComponent = loadable(() =>
  window.dynamicImport(QuoteComponentUrl)
);

export type IUploadFilePanelProps = {
  panelStyle?: PanelStyle;
  showInstantQuoteButton?: boolean;
  instantQuoteButtonContent?: React.ReactElement;
  panelScale?: PanelScale;
  segmentTrackPageSection?: string;
  layoutDirection?: LayoutDirection;
  processInitialism?: string;
  partConfiguration?: any;
  children: React.ReactElement;
  activeUserId?: string;
  showPartLibraryButton?: boolean;
  partLibraryButtonContent?: React.ReactElement;
  showPatentNotice?: boolean;
  showSecureBlurb?: boolean;
  showSupportedFileTypes?: boolean;
  Fallback: () => JSX.Element;
};

export const PanelStyleValues = [
  "blueGradient",
  "blueSolid",
  "graySolid",
  "whiteSolid",
  "transparent",
] as const;
export type PanelStyle = typeof PanelStyleValues[number];

export const LayoutDirectionValues = ["vertical", "horizontal"] as const;
export type LayoutDirection = typeof LayoutDirectionValues[number];

export const PanelScaleValues = ["small", "medium", "large", "xlarge"] as const;
export type PanelScale = typeof PanelScaleValues[number];

const UploadFilePanel = ({ Fallback, ...props }: IUploadFilePanelProps) => {
  const isSSR = typeof window === "undefined";

  if (!isSSR) {
    addImportDependencies();
  }

  return (
    <UploadFilePanelContainer>
      <QuoteUploadComponent fallback={<Fallback />} {...props} />
    </UploadFilePanelContainer>
  );
};

export default UploadFilePanel;
